import styled from 'styled-components';
import media from 'styled-media-query';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';

const Theme = Common.Theme;

export const BodyContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100vh;
	margin: 0 1rem;
	${media.lessThan('1200px')`
        width: 100%;
        margin: 0px 1rem;
    `}
`;

export const RootCard = styled.div`
	height: calc(100vh - 85px);
	background: ${Theme.white};
	box-shadow: 0 0 12px 0 ${Theme.shadow};
	border-radius: 4px;
	min-height: 40px;
	min-width: 100%;
	overflow: auto;
	scrollbar-width: thin;
	scrollbar-color: ${Theme.scrollThumb} ${Theme.scrollBar};
	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}
	&::-webkit-scrollbar-track {
		background: ${Theme.scrollBar};
	}
	&::-webkit-scrollbar-thumb {
		background: ${Theme.scrollThumb};
		border-radius: 8px;
	}
	&::-webkit-scrollbar-thumb:hover {
		background: ${Theme.scrollThumb};
	}
`;

export const TopBar = styled.div`
	display: flex;
	flex-direction: row-reverse;
	padding: 0.75rem 0;
	justify-content: space-between;
`;

export const DentiraLogo = styled(Common.DentiraLogo)``;

export const IconButton = styled(MUI.IconButton)``;

export const Hidden = styled(MUI.Hidden)``;

export const FlexRow = styled(Common.FlexRow)``;

export const NotFound = styled(Common.NotFound)``;

export const Button = styled(Common.Button)``;
